<app-sidebar>
  <div class="audit-page">
    <div class="page-nav">
      <button mat-stroked-button type="button" class="back-button" (click)="backToUsers()">
        <mat-icon>arrow_back</mat-icon>
        Back to manage users
      </button>
    </div>

    <div class="titles">
      <h1>Audit log</h1>
      <p class="subtitle" *ngIf="userEmail">{{ userEmail }}</p>
      <p class="subtitle mono" *ngIf="!userEmail">{{ userId }}</p>
    </div>

    <div class="filter-bar">
      <mat-form-field appearance="outline" class="filter-field">
        <mat-label>Filter actions</mat-label>
        <mat-select
          multiple
          [(ngModel)]="selectedActionFilters"
          [ngModelOptions]="{ standalone: true }">
          <mat-select-trigger>
            <span *ngIf="selectedActionFilters.length === 0">All actions</span>
            <span *ngIf="selectedActionFilters.length > 0">
              {{ selectedActionFilters.length }} selected
            </span>
          </mat-select-trigger>
          <mat-option *ngFor="let action of availableActions" [value]="action">
            {{ formatActionLabel(action) }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <button
        mat-button
        type="button"
        class="clear-filter-btn"
        *ngIf="selectedActionFilters.length > 0"
        (click)="clearActionFilters()">
        Clear
      </button>
    </div>

    <mat-chip-set class="filter-chip-set" *ngIf="selectedActionFilters.length > 0">
      <mat-chip
        *ngFor="let action of selectedActionFilters"
        [removable]="true"
        (removed)="removeActionFilter(action)">
        {{ formatActionLabel(action) }}
        <button matChipRemove aria-label="Remove action filter">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip>
    </mat-chip-set>

    <div *ngIf="loadingInitial" class="loading-spinner">
      <mat-spinner diameter="48"></mat-spinner>
    </div>

    <div *ngIf="!loadingInitial && entries.length === 0" class="empty-state">
      <mat-icon>event_note</mat-icon>
      <p>No audit entries for this user.</p>
    </div>

    <div *ngIf="!loadingInitial && entries.length > 0 && filteredEntries.length === 0" class="empty-state">
      <mat-icon>filter_list_off</mat-icon>
      <p>No audit entries match the selected filters.</p>
    </div>

    <mat-accordion *ngIf="!loadingInitial && filteredEntries.length > 0" class="audit-accordion">
      <mat-expansion-panel *ngFor="let entry of filteredEntries" (opened)="onPanelOpened(entry)">
        <mat-expansion-panel-header>
          <mat-panel-title class="panel-title">
            <span class="time">{{ formatTime(entry.timestamp) }}</span>
            <mat-chip class="action-chip">{{ formatActionLabel(entry.action) }}</mat-chip>
          </mat-panel-title>
          <mat-panel-description class="panel-desc">
            {{ entry.summary || '—' }}
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div class="meta-grid">
          <div><span class="label">Source</span> {{ entry.source || '—' }}</div>
          <div><span class="label">IP</span> {{ entry.ipAddress || '—' }}</div>
          <div class="span-2"><span class="label">User agent</span> {{ entry.userAgent || '—' }}</div>
        </div>

        <div class="detail-section" *ngIf="entry.hasDetails">
          <h3 class="detail-heading">Full entry</h3>
          <div *ngIf="detailLoadingIds.has(entry.id)" class="detail-loading">
            <mat-spinner diameter="32"></mat-spinner>
          </div>
          <p *ngIf="detailErrorById.has(entry.id)" class="detail-error">{{ detailErrorById.get(entry.id) }}</p>
          <pre *ngIf="detailJsonById.has(entry.id)" class="detail-json">{{ detailJsonById.get(entry.id) }}</pre>
        </div>
        <p *ngIf="!entry.hasDetails" class="no-detail">No structured details for this event.</p>
      </mat-expansion-panel>
    </mat-accordion>

    <div class="load-more-row" *ngIf="!loadingInitial && entries.length > 0 && nextCursor">
      <button mat-stroked-button type="button" (click)="loadMore()" [disabled]="loadingMore">
        <span *ngIf="!loadingMore">Load more</span>
        <span *ngIf="loadingMore">Loading…</span>
      </button>
    </div>
  </div>
</app-sidebar>
